import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUser } from "../../hooks/useUser";

const LoanRegisterButton = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const { t } = useTranslation("secondPart");
  const { isLoggedIn } = useUser();

  if (isLoggedIn) return null;

  return (
    <button
      onClick={() => navigate("/register")}
      style={{
        backgroundColor: "#ffffff",
        color: "#FF6500",
        borderRadius: "16px",
        border: "1px solid #FF6500",
        padding: "16px 20px",
        fontWeight: 600,
        fontSize: isDesktop ? "20px" : "16px",
        cursor: "pointer",
      }}
    >
      {t("registerClick")} <span style={{ marginLeft: "5px" }}>→</span>
    </button>
  );
};

export default LoanRegisterButton;
